import { Children, isValidElement, ReactElement, ReactNode, useMemo } from 'react';

interface WizardType {
  step: string;
  children: ReactNode;
}

export const Wizard = (props: WizardType) => {
  const content = useMemo(() => {
    const steps = Children.toArray(props.children);

    return (
      steps.find((item): item is ReactElement<WizardType> => {
        if (isValidElement<WizardType>(item)) return item.props.step === props.step;
        return false;
      }) || null
    );
  }, [props.step, props.children]);

  return content;
};

export const Step = (props: WizardType) => {
  return props.children;
};
